import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeletePartnerConfig(props) {

  return (
    <BasicModal
      popupOpen={props?.deleteHotelPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isHotelDeletedRef.current?.isHotelDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete Hotel Service Configuration<br/> <b>{props?.isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}</b> ?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>Hotel Service Configuration "{props?.isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}" will be permanently deleted <br />
              Deleting the specified Hotel Service Configuration can't be undone.
            </p>
            <p className="mt-3">To confirm deletion, type "Delete {props?.isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteHotel"
                  placeholder=''
                  onChange={(e) => props?.setConfirmDeleteHotelRow(e.target.value)}
                />
                <label htmlFor="deleteHotel">Delete {props?.isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}</label>
              </div>
              {(props?.confirmDeleteHotelRow === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}</small></p>
              ) : (props?.confirmDeleteHotelRow !== `Delete ${props?.isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}` && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isHotelDeletedRef.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isHotelDeletedRef.current?.isHotelDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            }
            ,
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deleteHotelHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeletePartnerConfig;
